var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("字典"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "dataFormRef",
    attrs: {
      model: _vm.formData,
      rules: _vm.formFules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("字典名称")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("字典名称")
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("标识"),
      disabled: _vm.isEdit ? true : false
    },
    model: {
      value: _vm.formData.mark,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mark", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "formData.mark"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字典类型"),
      prop: "type"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("字典类型")
    },
    model: {
      value: _vm.formData.type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "type", $$v);
      },
      expression: "formData.type"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("使用角色"),
      prop: "role"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("角色")
    },
    model: {
      value: _vm.formData.role,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "role", $$v);
      },
      expression: "formData.role"
    }
  }, _vm._l(_vm.roleList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      width: "60px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), (_vm.isEdit ? false : true) ? _c("a-checkbox", {
    staticClass: "marginL15",
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };